export const paymentModes = ["Bank", "Cash", "Card", "Cheque", "UPI"];
